import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { DateFormat } from '@as-react/common-types';
import { Box, TextAlpha } from '@yonderland/andes-react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
const AuthorDataContainer = ({ author, dateModified, dateCreated }) => {
    const { t } = useTranslation(I18N_NAMESPACES.seo);
    const dateLastModified = dateModified !== dateCreated ? dayjs(dateModified).format(DateFormat.DD_MM_YYYY_DASH) : null;
    if (!author)
        return;
    return (_jsx(Box, { paddingBlock: "4", paddingInlineStart: "4", children: _jsxs(TextAlpha, { variant: "bodyS", color: "subtle", as: "span", children: [t('author.data.by'), " ", author, dateLastModified && ` • ${t('author.data.update')} ${dateLastModified}`] }) }));
};
export default AuthorDataContainer;
